import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Css/Tickets.css'; // Import the CSS file
import tickitSvg from '../Images/Icon/tickets-icon.svg';
import alliconsImage1 from '../Images/Icon/allicons_0002_11.png';
import alliconsImage2 from '../Images/Icon/allicons_0000_1.png';
import alliconsImage3 from '../Images/Icon/allicons_0000_2.png';
import alliconsImage4 from '../Images/Icon/allicons_0003_10.png';
import resourceSvg from '../Images/Icon/resource.svg';

const Tickets = () => {
  return (
    <div className="custom-container">
      <div className="custom-header text-center">
        <img src={tickitSvg} alt="Ticket" className="ticket-svg" />
        <h2 className="ticket-text">TICKETS</h2>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/cases/pon" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage1} className="card-img-top mb-2" alt="PON" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">PON</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/cases/add_summon1" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage2} className="card-img-top mb-2" alt="PART 1 SUMMONS" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">PART 1 SUMMONS</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/cases/add_summon3" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage2} className="card-img-top mb-2" alt="PART 3 SUMMONS" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">PART 3 SUMMONS</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/release_form/add" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage3} className="card-img-top mb-2" alt="APPEARANCE NOTICE" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">APPEARANCE NOTICE</h5>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/form10/add" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage3} className="card-img-top mb-2" alt="UNDERTAKING" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">UNDERTAKING</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/impound/add" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={alliconsImage4} className="card-img-top mb-2" alt="IMPOUND / SUSPENSION FORM" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">IMPOUND / SUSPENSION FORM</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/pdf_resources/pdf_upload_list" className="text-decoration-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img src={resourceSvg} className="card-img-top mb-2" alt="RESOURCES" />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">RESOURCES</h5>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Tickets;